<template>
  <!-- About Section -->
  <section class="about-section" id="about">
    <div class="container">
      <div class="about-header">
        <h2 class="section-title">{{ locale === 'tr' ? 'Hakkımızda' : 'About Us' }}</h2>
        <p class="section-subtitle">{{ locale === 'tr' ? 'Enerji sektöründe güvenilir çözüm ortağınız' : 'Your trusted solution partner in the energy sector' }}</p>
      </div>
      
      <div class="about-content">
        <div class="about-main">
          <div class="about-image">
            <img src="/images/aslan-energy-logo-hq.jpg" alt="Aslan Energy Logo" class="about-logo" />
            <div class="about-overlay">
            </div>
          </div>
          
          <div class="about-text">
            <div class="about-intro">
              <h3>{{ locale === 'tr' ? 'Sürdürülebilir Enerji Lideri' : 'Sustainable Energy Leader' }}</h3>
              <p class="intro-text">{{ locale === 'tr' ? 'Aslan Energy olarak, yenilenebilir enerji alanında uzman kadromuz ve modern teknolojimizle sürdürülebilir çözümler sunuyoruz.' : 'As Aslan Energy, we provide sustainable solutions in the renewable energy field with our expert team and modern technology.' }}</p>
            </div>
            
            <div class="about-features">
              <div class="feature-item" v-for="(feature, index) in aboutFeatures" :key="index">
                <div class="feature-icon">
                  <img v-if="feature.icon_url" :src="feature.icon_url" :alt="feature.title" class="feature-icon-img" />
                  <div v-else class="feature-icon-svg" v-html="feature.icon_svg"></div>
                </div>
                <div class="feature-content">
                  <h4>{{ locale === 'tr' ? feature.title_tr : feature.title_en }}</h4>
                  <p>{{ locale === 'tr' ? feature.description_tr : feature.description_en }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="mission-vision-grid">
          <div class="mission-card" v-for="(card, index) in missionVisionCards" :key="index">
            <div class="card-background" :style="{ backgroundImage: `url(${card.background_image})` }"></div>
            <div class="card-overlay"></div>
            <div class="card-content">
              <div class="card-icon">
                <img v-if="card.icon_url" :src="card.icon_url" :alt="card.title" class="card-icon-img" />
                <div v-else class="card-icon-svg" v-html="card.icon_svg"></div>
              </div>
              <h4>{{ locale === 'tr' ? card.title_tr : card.title_en }}</h4>
              <p>{{ locale === 'tr' ? card.description_tr : card.description_en }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useAbout } from '@/composables/useAbout'

// Props
defineProps({
  locale: {
    type: String,
    default: 'tr'
  }
})

// Composable kullanımı
const { aboutFeatures, missionVisionCards } = useAbout()
</script>